export default {
  allDay: 'All day',
  add: 'Add',
  added: 'Added',
  addMore: 'Add more',
  areYouSure: 'Are you sure?',
  cancel: 'Cancel',
  cancelHabit: 'Cancel repeat',
  changesToSync: 'changes to sync',
  clear: 'Clear',
  confirm: 'Confirm',
  confirmExactTime: 'Confirm',
  copied: 'Add copied content to list?',
  custom: 'Custom',
  email: 'Email',
  pleaseEnterValidEmail: 'Please enter a valid email',
  pleaseEnter6DigitCodeFromEmail: 'Please enter the 6-character code in the email you received',
  didntGetTheCodeQuestion: 'Didn\'t get the code?',
  pleaseTakeAMinuteToReviewAndAccept: 'Please take a minute to review our Terms of Service and Privacy Policy',
  proceed: 'Proceed',
  resendCode: 'Resend Code',
  pleaseReviewAndAcceptOur: 'Please review and accept our',
  privacyPolicy: 'Privacy Policy',
  termsOfService: 'Terms of Service',
  simplyEnterYourEmailAndWellSendYouALink: 'Simply enter your email and we\'ll send you a code. More secure and less to remember than passwords.',
  pleaseReviewAndAcceptToProceed: 'Please review and accept to proceed',
  weValueYourPrivacy: 'We Value Your Privacy',
  terms: 'Terms',
  every: 'Every',
  everyMonth: 'every month',
  everyYear: 'every year',
  gotcha: 'Gotcha',
  habit: 'Repeat',
  inOneMonth: 'In a month',
  iWouldLikeToBeAbleTo: 'I\'d like to be able to..',
  justSwipe: 'Just Swipe',
  laterToday: 'Later today',
  leaveFeedback: 'Leave Feedback',
  likeItRateIt: 'Like it? Rate it!',
  listname_deleted: 'Deleted items',
  listname_done: 'Completed Items',
  listname_postponed: 'Later',
  listname_todo: 'To Do',
  login: 'Connect',
  loginNow: 'Connect now',
  loginOrSignup: 'Login or sign up',
  loginToSync: 'Connect to sync with other devices',
  logMeOutAnyway: 'Log me out anyway',
  nothingPlanned: 'All clear, no tasks planned yet!',
  movedTo: 'Moved to',
  nextWeek: 'Next week',
  nextWeekend: 'Next weekend',
  noTasksLeft: 'No tasks left!',
  notLoggedIn: 'Not logged in',
  offlineMode: 'Offline mode',
  ok: 'Ok',
  online: 'Online',
  openLink: 'Open link',
  password: 'Password',
  profile: 'Profile',
  recurring_day: 'Daily',
  recurring_month: 'Monthly',
  recurring_week: 'Weekly',
  recurring_year: 'Yearly',
  save: 'Save',
  selectAll: 'Select All',
  sessionExpired: 'Session Expired',
  signOut: 'Sign out',
  signup: 'Sign up',
  specifyAnExactTime: 'Set an exact time',
  spreadTheLove: 'Spread the love',
  startAt: 'Beginning',
  startByAddingATask: 'Start by adding a task',
  status_deleted: 'Delete',
  status_done: 'Done',
  status_postponed: 'Later',
  status_todo: 'To Do',
  swipeToComplete: 'Swipe to complete',
  swipeToPlanForLater: 'Swipe to plan for later',
  thisEvening: 'This evening',
  thisWeekend: 'This weekend',
  themeSelector: 'Themes',
  tomorrow: 'Tomorrow',
  tomorrowEvening: 'Tomorrow evening',
  toTheLeft: 'To the left',
  toTheRight: 'To the right',
  undo: 'Undo',
  updated: 'Updated',
  updatedScheduleTo: 'Updated repeat to',
  whatCanWeDoBetterPleaseLetUsKnow: 'What can we do better? Please let us know!',
  youHaveUnsyncedChangesThatWillBeLost: 'You have unsynced changes that will be lost',
  youNeedToLoginAgain: 'You need to login again',
  allowLysterCalendarAccess: 'Allow Lyster to access your calendars to get a full view of your day',
  allowNow: 'Allow Now',
  later: 'Later',
  calendars: 'Calendars',
  hideUpcoming: 'Hide upcoming',
  showEntireDay: 'Show entire day',
  nextMeetingAt: 'Next meeting at',
  thingsLaterToday: 'things later today',
  allDoneGoodJob: 'All done, good job!',
  after: 'After',
  today: 'Today',
  yesterday: 'Yesterday',
  last: 'Last',
  refresh: 'Refresh',
  empty: 'Nothing here yet, your move! :)',
  changedOrder: 'Changed order of tasks',
  autoDarkMode: 'Auto Dark Mode',
  readingList: 'Reading List',
  automaticallyAddToSafariReadingList: 'Add links to Safari Reading List automatically',
  tipReadLaterOffline: 'Tip: Enable "Automatically Save Offline" in your Safari Settings to make links available offline',
  timingSettings: 'Timing settings',
  lysterPremiumComingSoon: 'Lyster Premium coming soon!',
  premium: 'Premium',
  premiumInfo: "We'll soon launch Schedulist! It will introduce categorization, integrations and collaboration while keeping the simplicity of Lyster",
  startWeeksOn: 'Start weeks on',
  startEveningsAt: 'Start evenings at',
  startMorningsAt: 'Start mornings at',
  pleaseSpecifyATimeBetween: 'Please specify a time between',
};
